<div class="overlay">
    <img ngSrc="images/logos/mb-loading.gif" height="100" width="100" priority="low" alt="logo" />
</div>